import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from './../../../../../root-store/login-store/login.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'instructions_gather',
  templateUrl: './instructions_gather.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryInstructionsGatherComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  mainTitle;
  subscription = new Subscription();
  instructions = [
    {
      title: 'Gather items on the checklist',
      imageNumber: '2',
      instructionLists: [
        'You can <span class="font-bold"> download the checklist </span> on the next page.',
        'If there are several items, you might want to <span class="font-bold"> print a copy </span>.',
        'Focus on items which are <span class="font-bold"> currently accessible </span> on the list.',
        'We recommend putting hard copies in a <span class="font-semibold"> physical folder </span> and digital items in a <span class="font-bold"> digital folder </span> on a trusted computer.',
      ],
    },
    {
      title: 'Mark items on the PDF appropriately',
      imageNumber: '3',
      instructionLists: [
        'Check the appropriate box, indicating whether a <span class="font-bold"> physical copy </span> or <span class="font-bold"> digital copy </span> was gathered.',
        'You may also mark boxes that indicate if you need to <span class="font-semibold"> come back to something later </span> or <span class="font-bold"> remove </span> items that are not applicable.',
      ],
    },
    {
      title: 'Complete the internal checklist review',
      imageNumber: '6',
      instructionLists: [
        'Indicate the <span class="font-bold"> status </span> of each item on the checklist in Kinnect.',
        'If you printed off a <span class="font-bold"> PDF Checklist </span> in the previous step, you will want to have that handy for the checklist review.',
      ],
    },
  ];

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.mainTitle = `<span class="font-bold text-[#25508E]">Gather documents </span> to set up  <span class="font-bold text-[#25508E]"> ${user?.first_name}’s ${this.data?.path_name} </span>`;
      })
    );
  }

  instructionBackOrForwardEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
